import React from "react";
import { Link } from "react-router-dom";
import Mask from "../../services/mask";
import semImg from "../../assets/images/pngs/semImg.png";
import "./index.css";

export default function CardProduto({ product, customRoute }) {
  // Se customRoute for fornecido, usa ele, senão usa a rota padrão
  const route = customRoute || "/catalogo/vitrine-leo/" + product?.produtoId;

  if (!product || !product.produtoId) {
    return null;
  }

  return (
    <Link to={route} className="cardLink" onClick={(e) => e.stopPropagation()}>
      <div className="cardProduto">
        <div className="divImagem">
          <img
            className="imagemProduto"
            src={product.urlImagem !== "" ? product.urlImagem : semImg}
            alt={product.titulo || "Produto"}
          />
        </div>

        <div className="divDetalhes">
          <span className="tituloProduto">{product.titulo || ""}</span>
          <div className="btnPontos">
            {Mask.numeroPontos((product.pontos || 0).toString())} PONTOS
          </div>
        </div>
      </div>
    </Link>
  );
}

